import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppLinks"] */ "/app/src/components/AppLinks/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialogs"] */ "/app/src/components/dialogs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterClientWrapper"] */ "/app/src/components/general/Footer/FooterClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyright"] */ "/app/src/components/general/Footer/FooterCopyright.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterImages"] */ "/app/src/components/general/Footer/FooterImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMenu"] */ "/app/src/components/general/Footer/FooterMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScFooter","ScFooterItem","ScFooterItemRight","ScFooterImagesGroup","ScFooterItemLeft","ScFooterSocialLinks","ScAppLinks","ScLicense"] */ "/app/src/components/general/Footer/styled.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderDesktop"] */ "/app/src/components/general/Header/HeaderDesktop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMobile"] */ "/app/src/components/general/Header/HeaderMobile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabBar"] */ "/app/src/components/general/TabBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageComponent"] */ "/app/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchLanguage"] */ "/app/src/components/SwitchLanguage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["sendEventToAnalyticsFn"] */ "/app/src/helpers/analytics.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ClientCommonLayout"] */ "/app/src/layouts/ClientCommonLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScServerLayoutContainer"] */ "/app/src/layouts/styled.ts");
;
import(/* webpackMode: "eager" */ "/app/src/store/StoreClient.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ScContainer"] */ "/app/src/styles/common.ts");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/all.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowDownSmallIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowLeftIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowRightWhiteIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/arrowUpGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/basketIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/betIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusBuy.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/depNumber.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/frequency.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/fsAmount.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/game.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/hourglass.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/info.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxBonus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxCashout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/maxWinFs.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/minDep.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/prize.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/rtp.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/tick.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/wager.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/bonusTerms/wagerDark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/btc.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/burgerIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/casinoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/casual.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/categoryDefault.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/checkIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/clockIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/closeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossInCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/crossWhiteIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/cup.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/currencyIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/dropdownArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/envelopeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/equalitySign.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/errorIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/eyeClosedIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/eyeOpenIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/globeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/grayBetIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/greyHeartIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartFullIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/heartIconDouble.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/homeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/homeStrokeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIconCircle.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/infoIconTooltip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/jackpot.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/jackpotIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/jackpotIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/live.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lockIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/logoMin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lupIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/lupIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/magnifier.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/magnifierLargeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/menuIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/minusIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/moneyBag.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/new.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/newIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/newNotificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/notificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/notificationWithBadgeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/playIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconBlack.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconBoldWhite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/plusIconGrey.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/presentIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/presentSmallIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizeIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizePoolBlackIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/prizePoolIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/activeSessionsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/addressIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/arrowSelectIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/changePasswordIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/coolingOffIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/crossIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/depositHistoryRowIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/depositLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/faileFileUploadIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/fileUploadIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/identityIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/imageIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/linkBoldIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/lossLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/paymentIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/pdfIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/selfExclusionIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/tooltipIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/trashIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/twoFactorIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/verifyEmailIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/verifyNotificationIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/wagerLimitsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profile/withdrawalHistoryRowIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/profileIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/1spin4win.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/1x2gaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/3oaks.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/4theplayer.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/acerun.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/amatic.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/amusnet.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/apparat.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/authenticgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/avatarux.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/baddingo.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bangbanggames.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bbgames.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/belatra.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bluegurugames.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/blueprint.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/boomerangstudios.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/booming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/booongo.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bsg.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/bulletproof.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/casinotechnology.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/electricelephant.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/elk.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/endorphina.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/evolution.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/evoplay.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/ezugi.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/felixgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/fourleafgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gameart.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gamebeat.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gamesinc.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gameslab.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gamevy.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/gamzix.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/habanero.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/hotrisegames.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/igrosoft.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/igtech.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/irondogstudio.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/isoftbet.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/jaderabbit.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/jelly.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/kagaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/lucky.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/luckystreak.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/mancala.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/mascot.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/merkur.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/mrslotty.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/netent.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/netgame.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/nolimit.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/northernlights.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/nucleus.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/onlyplay.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/petersons.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/placeholder.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/platipus.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/playngo.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/playson.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/playtech.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/popiplay.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/pragmaticplay.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/pragmaticplaylive.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/printstudios.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/pushgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/quickfire.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/quickspin.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/redtiger.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/reellifegames.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/reelplay.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/reevo.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/reflexgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/relax.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/relaxgaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/retrogaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/silverback.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/smartsoft.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/spinomenal.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/spribe.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/swintt.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/technology.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/thunderkick.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/vivogaming.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/wazdan.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/yggdrasil.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers/zillion.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providers1Icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/providersIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/randomizeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/searchGrayIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/searchIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/slots.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/spinsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/sportsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/successCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/successIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/supportIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/app.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/casino.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/jackpotTabBar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/lobby.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/profile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/promo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/quest.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/signout.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/sports.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/sportsMobileMenuIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/tournaments.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tabBarMenu/vip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/table.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/termsAndConditionsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleDeclineIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickCircleIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/tickIcon1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/topicsIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/trending.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/trendingIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/wagerIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/warningIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/whiteArrowRight.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/whiteInfoIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/theme/images/withdrawalIcon.svg");
